import React, { Suspense } from 'react';
import IntellectLogo from '../../../../assets/intellect-logo.svg';
import { AnimatePresence, motion } from 'motion/react';
import { Typography } from '../../../widgets/Typography';

const loadingTexts = [
  'Compiling workplace mental health statistics',
  'Processing organization-wide wellbeing patterns',
  'Aggregating anonymized workforce data',
];

export default function WidgetLayoutLoadingBoundary({
  children,
}: React.PropsWithChildren) {
  const [loadingTextIndex, setLoadingTextIndex] = React.useState(
    Math.floor(Math.random() * loadingTexts.length),
  );

  React.useEffect(() => {
    const interval = setInterval(() => {
      setLoadingTextIndex((prevIndex) => (prevIndex + 1) % loadingTexts.length);
    }, 1500);

    return () => clearInterval(interval);
  }, []);

  return (
    <Suspense
      fallback={
        <div className="bg-taupe-50 fixed z-40 flex h-screen w-screen flex-col items-center justify-center gap-4">
          <motion.div
            className="origin-center"
            initial={{ rotate: 0, scale: 1 }}
            animate={{ rotate: [0, 360], scale: [1, 1.1, 1] }}
            transition={{ repeat: Infinity, duration: 0.8 }}
          >
            <img src={IntellectLogo} alt="Intellect Logo" className="w-8" />
          </motion.div>
          <AnimatePresence mode="popLayout">
            <motion.div
              className="flex w-full justify-center"
              key={loadingTextIndex}
              initial={{ opacity: 0, filter: 'blur(4px)' }}
              animate={{
                opacity: 1,
                filter: 'blur(0px)',
              }}
              exit={{ opacity: 0, filter: 'blur(4px)' }}
              transition={{ duration: 0.4 }}
            >
              <Typography
                variant="body-sm"
                className="text-center text-neutral-500"
              >
                {loadingTexts[loadingTextIndex]}
              </Typography>
            </motion.div>
          </AnimatePresence>
        </div>
      }
    >
      {children}
    </Suspense>
  );
}
